'use client';

import { I18nextProvider } from 'react-i18next';
import { PropsWithChildren } from 'react';
import { i18nInstance } from '../../i18n/client';

export const I18nProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
);
